import gql from 'graphql-tag';
import { map, sortBy } from 'lodash';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';

import { changeProcedure } from './ProcedureDropdownActions';
import { ProcedureDropdownView } from './ProcedureDropdownView';

export const GET_PROCEDURES = gql`
    query getProvider($providerId: String, $directoryId: String) {
        provider(id: $providerId, directoryId: $directoryId){
            id,
            procedures {
                id
                name
                insuranceMayNotCover
            },
            popularProcedures {
                id
                name
                insuranceMayNotCover
            }
        }
    }
`;

export const parseGql = ({ data }) => {
    if (data.loading) {
        return {
            procedures: [],
            loading: true,
        };
    } else if (!data.error && data.provider && data.provider.procedures && data.provider.procedures.length > 0) {
        const popularProcedures = new Set(map(data.provider.popularProcedures, 'id'));
        return {
            procedures: sortBy(data.provider.procedures.filter(it => !popularProcedures.has(it.id)), 'name'),
            popularProcedures: sortBy(data.provider.popularProcedures, 'name'),
        };
    }

    return { procedures: [] };
};

const withSortedProviderProcedures = graphql(GET_PROCEDURES, {
    skip: ({ providerId }) => !providerId,
    options: ({ directoryId, providerId, theme }) => ({
        variables: {
            providerId,
            directoryId: directoryId || theme.directoryId,
        },
    }),
    props: parseGql,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onProcedureChange: (...args) => {
        dispatch(changeProcedure(...args));

        if (ownProps.onProcedureChange) {
            ownProps.onProcedureChange(...args);
        }
    },
});

const ProcedureDropdownViewWithData = withSortedProviderProcedures(ProcedureDropdownView);
const ThemedProcedureDropownViewWithData = withTheme(ProcedureDropdownViewWithData);

export const ProcedureDropdownContainer = connect(null, mapDispatchToProps)(ThemedProcedureDropownViewWithData);
